import { connect } from 'react-redux'
import DialInRegionSelector from './DialInRegionSelector'
import { State } from '../../dataStore/reducers/reducerType'
import { fetchDialInCode, fetchDialInPhoneNumbers, setSelectedPhoneNumber } from '../../dataStore/actions/dialIn/dialInActions'
import { DialInRegionSelectorProps } from './types'
import structuredSelectPresenter from '../../dataStore/selectors/structuredSelectPresenter'

const mapStateToProps = (state: State, props): Omit<DialInRegionSelectorProps, 'fetchDialInCode' | 'fetchDialInPhoneNumbers' | 'setSelectedPhoneNumber'> => ({
  label: props.label,
  switchComponent: props.switchComponent,
  participant: structuredSelectPresenter(state, { BTID: state.user.BTID || ''}),
  roomname: state.config.roomname || '',
  phoneNumbers: state.dialIn.phoneNumbers,
  selectedPhoneNumber: state.dialIn.selectedPhoneNumber,
  code: state.dialIn.code,
  isFetchingPhoneNumbers: state.dialIn.phoneNumberFetchStatus === 'fetching',
  isFetchingParticipantCode: state.dialIn.codeFetchStatus === 'fetching'
})

const mapDispatchToProps = (dispatch) => ({
  fetchDialInCode: (roomname, participant) => dispatch(fetchDialInCode(roomname, participant)),
  fetchDialInPhoneNumbers: (roomname) => dispatch(fetchDialInPhoneNumbers(roomname)),
  setSelectedPhoneNumber: (phoneNumber) => dispatch(setSelectedPhoneNumber(phoneNumber))
})

export default connect(mapStateToProps, mapDispatchToProps)(DialInRegionSelector)
